<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 339.0 71.0">
    <defs>
      <clipPath id="a">
        <path d="M1670 0v10455H0V0h1670z"/>
      </clipPath>
      <clipPath id="b">
        <path d="M338.124 0v10.65H306.97v18.967h27.702v10.345H306.97V60.35h31.154V71h-43.231V0h43.23zm-205.29 0v60.147h26.892V71h-39.07V0h12.178zm146.331 0v10.752h-19.789V71H247.2V10.752h-19.789V0h51.754zM172.309 0l12.38 20.691c2.131 3.55 4.16 6.999 5.379 10.042 1.217-3.043 3.247-6.593 5.378-10.143L207.724 0h13.7l-25.268 41.282V71h-12.278V41.282L158.305 0h14.004zM98.636 0v7.201c-1.928-1.014-3.754-1.014-5.682-1.014H83.11v8.825h7.611c1.826 0 3.653-.203 5.48-1.217v7.91c-1.827-1.014-3.654-1.014-5.48-1.014h-7.61v9.332h10.552c1.624 0 3.35 0 4.973-1.014v7.201h-23.34c1.015-1.42 1.015-2.84 1.015-4.26V4.868c-.004-1.623-.06-3.245-1.015-4.868h23.34zM28.008 0v7.303c-1.928-1.116-3.755-1.217-5.683-1.217h-4.77v25.828c.004 1.432.06 2.864 1.015 4.296H9.437c1.015-1.42 1.015-2.941 1.015-4.362V6.086H5.683c-1.928 0-3.755.101-5.683 1.217V0h28.008zm16.237 0C43.23 1.521 43.23 3.043 43.23 4.565v10.447h14.41V4.11c-.004-1.347-.06-2.774-1.015-4.11h9.031c-1.015 1.521-1.015 3.043-1.015 4.565v27.35c.004 1.431.06 2.863 1.015 4.295h-9.031c1.014-1.42 1.014-2.941 1.014-4.362v-10.75H43.23v10.548c0 1.521 0 3.042 1.016 4.564H35.11c1.015-1.42 1.015-2.941 1.015-4.362V4.11c-.003-1.347-.06-2.774-1.015-4.11z"/>
      </clipPath>
    </defs>
    <g clip-path="url(#a)" transform="translate(-100 -242)">
      <g clip-path="url(#b)" transform="translate(100 242)">
        <path :fill="fillColor" d="M0 0h338.124v71H0V0z"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'MainLogo',
  props: {
    fillColor: {
      type: String,
    },
    fontColor: {
      type: String,
      default: '#000'
    }
  }
}
</script>

<style scoped>

</style>
